import { useEffect } from 'react'
import { scrollToReveal, cancelScrollAnimation } from '../scroll'

// Scrolls ref.current into the reveal position (see Shared/scroll) whenever
// `active` flips true — for content that mounts off-screen, like an expanded
// table below a long list. Going inactive or unmounting cancels an in-flight
// animation instead of letting it finish toward a stale target.
const useScrollReveal = (ref, active, { topRatio } = {}) => {
  useEffect(() => {
    if (!active) {
      return undefined
    }

    scrollToReveal(ref.current, { topRatio })
    return () => cancelScrollAnimation()
  }, [ ref, active, topRatio ])
}

export default useScrollReveal
